import React, { FunctionComponent } from 'react';

type Props = {
  isBookmarked: boolean;
  onCreateBookmark: () => void;
  onDeleteBookmark: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isBookmarked,
  onCreateBookmark,
  onDeleteBookmark,
}) => {
  return (
    <>
      {isBookmarked ? (
        <div
          data-category="scout_user_detail"
          data-event="click"
          data-value="bookmark"
          className="l-profile-sub-bookmarked"
          onClick={onDeleteBookmark}
        >
          <span>
            <i className="fa fa-bookmark" aria-hidden="true"></i>
            <p>ブックマークを解除</p>
          </span>
        </div>
      ) : (
        <div
          data-category="scout_user_detail"
          data-event="click"
          data-value="bookmark"
          className="l-profile-sub-bookmark"
          onClick={onCreateBookmark}
        >
          <span>
            <i className="fa fa-bookmark" aria-hidden="true"></i>
            <p>ブックマークに登録</p>
          </span>
        </div>
      )}
    </>
  );
};
